import { useEffect, useRef, useState } from 'react';
import isNil from 'lodash/isNil';
import { GIC_LIFECYCLE_EVENTS } from '@atlassian/jira-issue-create-extensibility/src/common/utils/lifecycle-events/constants.tsx';
import { useGICLifeCycleEvents } from '@atlassian/jira-issue-create-extensibility/src/common/utils/lifecycle-events/main.tsx';

export const useSetSummary = (initialSummaryValue: string | null) => {
	const [summaryValue, setSummary] = useState<string | null>(
		initialSummaryValue || initialSummaryValue === null ? initialSummaryValue : '',
	);

	const hasSetInitialValue = useRef<boolean>(false);
	if (!hasSetInitialValue.current && !isNil(initialSummaryValue)) {
		hasSetInitialValue.current = true;
		setSummary(initialSummaryValue);
	}

	const { subscribe } = useGICLifeCycleEvents();

	useEffect(() => {
		subscribe(
			GIC_LIFECYCLE_EVENTS.CREATE_FORM_FIELD_VALUE_CHANGE,
			async (data: { fieldId: string; value: React.SetStateAction<string> }) => {
				if (data.fieldId === 'summary') {
					setSummary(data.value.toString());
				}
			},
		);
		subscribe(GIC_LIFECYCLE_EVENTS.MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE, async () => {
			setSummary('');
		});
	}, [subscribe, setSummary]);

	useEffect(
		() =>
			subscribe(GIC_LIFECYCLE_EVENTS.ISSUE_CREATE_SUCCESS, async () => {
				setSummary('');
			}),

		[subscribe, setSummary],
	);

	return summaryValue;
};
